<div
  echarts
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
  (chartClick)="onChartClick($event)"
  class="dot-plot-chart"
></div>
